export default "__VITE_ASSET__3c39afd2__"